export const CONFIRMATION_RULE_TEXT: Record<string, string> = {
  zoneDistanceImbalanceNote:
    'Zone distances in this configuration vary by more than 2x. Consider balancing zone placement for optimal performance.',
  heatingCapacityImbalanceNote:
    'Zone heating capacities in this configuration are not balanced. Consider adjusting zone composition for even load distribution.',
  differentSunExposure:
    'Spaces with different sun exposure may benefit from separate zones.',
  openConceptFightingThermostats:
    'These open spaces are strongly connected. A single zone may perform better here.',
  smallSpaceDedicatedZone:
    'This space is very small for a dedicated zone. Consider conditioning indirectly or pairing with a nearby space.',
  kitchenMakeupAir:
    'Kitchen exhaust may impact comfort and loads. Confirm ventilation/makeup air assumptions.',
  wallHeadOverHeatSource:
    'Avoid placing the air handler above major heat sources; it can cause control issues.',
  wallHeadDischargeBlocked:
    'Air handler airflow may be blocked by nearby walls/doors/furniture.',
  shortestPracticalLineset:
    'Consider placing the indoor unit closer to an exterior wall to reduce lineset length and complexity.',
  singleCondenserNoRedundancy:
    'Single condenser means no redundancy if the system goes down. Consider splitting capacity across multiple condensers.',
  additionalRefrigerantChargeRequired:
    'Total lineset length exceeds the factory charge allowance. Additional refrigerant charge will be required.',
  trapLoopNeededVerticalDrops:
    'Long vertical run detected. Verify if oil traps/loops are required per manufacturer guidance.',
  leaveExtraWiringLength: 'Wiring should be slightly longer than the line set.',
  outdoorDisconnectRequired:
    "Outdoor disconnect is required for service. Ensure it's included in the install plan.",
  pumpNoiseRiskBedrooms:
    'Condensate pumps in bedrooms can be noisy. Consider a gravity drain if possible.',
  addRiseAfterPumpDischarge:
    'Add 3-6 inches of rise after condensate pump discharge.',
  outdoorUnitNoiseBedroom:
    'Verify condenser sound levels and location near bedrooms/property lines.',
  coastalCorrosiveProtection:
    'Corrosive environment detected. Consider anti-corrosion coatings and protective placement.',
  outdoorUnitDefrostWater:
    'Plan for defrost water runoff to avoid ice buildup and hazards.',
  differentControlStylesInHome:
    'This design uses multiple control platforms. Consider standardizing for a better user experience.',
  backupHeatExtremeCold: 'Consider backup heat for extreme cold conditions.',
  highAltitudeDerating:
    'High altitude may reduce equipment capacity. Verify derating requirements.',
  ventilationNeededTightHomes:
    'Mini-splits do not provide fresh air. Consider ventilation (ERV/HRV) for tight homes.',
  filterAccessBlocked:
    'Ensure filter can be removed for cleaning without obstructions.',
  prefer1to1FarZones:
    'Zones are spread out. Multiple 1:1 systems may be simpler and perform better than one multi-zone.',
  complexityWarning:
    'System complexity is high for the home size. Consider simplifying zoning/equipment.'
};

export const CONFIRMATION_RULE_IDS: string[] = [
  'zoneDistanceImbalanceNote',
  'heatingCapacityImbalanceNote',
  'differentSunExposure',
  'openConceptFightingThermostats',
  'smallSpaceDedicatedZone',
  'kitchenMakeupAir',
  'wallHeadOverHeatSource',
  'wallHeadDischargeBlocked',
  'shortestPracticalLineset',
  'singleCondenserNoRedundancy',
  'additionalRefrigerantChargeRequired',
  'trapLoopNeededVerticalDrops',
  'leaveExtraWiringLength',
  'outdoorDisconnectRequired',
  'pumpNoiseRiskBedrooms',
  'addRiseAfterPumpDischarge',
  'outdoorUnitNoiseBedroom',
  'coastalCorrosiveProtection',
  'outdoorUnitDefrostWater',
  'differentControlStylesInHome',
  'backupHeatExtremeCold',
  'highAltitudeDerating',
  'ventilationNeededTightHomes',
  'filterAccessBlocked',
  'prefer1to1FarZones',
  'complexityWarning'
];

export function getValidationCategory(sectionId: string): string | null {
  if (sectionId.startsWith('add_spaces_zone_')) return 'zones';
  if (['condensers', 'air_handlers', 'line_sets'].includes(sectionId))
    return sectionId;
  return null;
}

const CATEGORY_ORDER = ['zones', 'condensers', 'air_handlers', 'line_sets'];

export function getAllowedCategories(
  currentCategory: string | null
): Set<string> {
  if (!currentCategory) return new Set(CATEGORY_ORDER);
  const idx = CATEGORY_ORDER.indexOf(currentCategory);
  if (idx === -1) return new Set(CATEGORY_ORDER);
  return new Set(CATEGORY_ORDER.slice(0, idx + 1));
}
